import * as types from "./mutation-types";

export default {
  [types.SET_MUNICIPIOS](state, payload) {
    state.municipios = payload;
  },
  [types.SET_MUNICIPIO](state, payload) {
    state.municipio = payload;
  },
  [types.SET_ESTADOS](state, payload) {
    state.estados = payload;
  },
  [types.SET_ESTADO](state, payload) {
    state.estado = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
